// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Service
import UserService from '@/app/services/main/user/user-service.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

// Third Party Libraries
import $ from 'jquery';

export default {
	name: 'ModalAddAdmin',
	mixins: [toastMessageMixins],
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				userEmail: {},
				userFirstName: {},
				userLastName: {}
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true);
			fields = vuelidateUtil.setEmailValidation(fields, 'userEmail');

			return fields;
		},
		isInvalid() {
			const { $invalid } = this.$v;
			return $invalid || this.isAPILoading;
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		initializeModalData() {
			return {
				userEmail: '',
				userFirstName: '',
				userLastName: '',
				isAPILoading: false
			}
		},
		show() {
			this.resetModalData();
			$(this.$refs.modalAddAdmin).modal('show');
		},
		closeModal() {
			$(this.$refs.modalAddAdmin).modal('hide');
		},
		resetModalData() {
			Object.assign(this.$data, this.initializeModalData());
			this.$v.$reset();
		},
		async addAdmin(singleAdd) {
			await this.callAddAdminAPI();
			this.isAPILoading = false;

			if (singleAdd) {
				this.closeModal();
			} else {
				this.resetModalData();
			}
		},
		callAddAdminAPI() {
			const userData = {
				firstName: this.userFirstName,
				lastName: this.userLastName,
				email: this.userEmail
			};
			this.isAPILoading = true;

			return UserService.postAdminUser(userData)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast('An email has been sent to this user.');
						this.$emit('refreshTableContent');
					} else {
						this.showAPIErrorToast('Unable to add Admin User', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		}
	},
	validations() {
		return this.validationRules;
	}
}